import React, { Fragment, useState } from 'react';

// import '../../../../Settings/Users/styles.scss';
import lupa from '../../../../../assets/images/lupaReport.svg';
import OrgListUsers from './Components/OrgListUsers';

/**
 * Component for showing the org list of users
 *
 * @param {*} { parentFilter }
 * @returns
 */
const OrgListUsersScreen = ({ parentFilter }) => {
  const [searchTerm, setSearchTerm] = useState('');

  /**
   * Called when the search term input change
   * @param {*} event
   */
  const onChangeInputSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <Fragment>
      <div className="container-info-list-users">
        <div className="body-info-relatorio container-elements">
          <p className="list-user-title">Usuários</p>
          <div className="input-search-list-users">
            <img src={lupa} />
            <input
              placeholder="Pesquisar"
              className="input-bots-users"
              onChange={onChangeInputSearch}
            />
          </div>
          <OrgListUsers parentFilter={parentFilter} searchTerm={searchTerm} />
        </div>
      </div>
    </Fragment>
  );
};

export default OrgListUsersScreen;
